import React from 'react';
import { Footer } from './components/common'
import Route from './Route'


function App() {
  return (
    <div className="App">
      <Route />
      <Footer />
    </div>
  );
}

export default App;
